import Practice from './Practice';

export default Practice;
